import {
  TypedUseQueryHookResult,
  skipToken,
} from '@reduxjs/toolkit/dist/query/react';

import { useFetchPlumbingQuery } from './plumbingService';

import { AxiosBaseQueryFunction } from '~/api/axiosBaseQuery';
import { CommonProductQueryParams } from '~/api/easy-estimator-api/commonProductQueryParams';
import { useSelectedStore } from '~/api/easy-estimator-api/stores-api/useSelectedStore';
import { shouldFetchFn } from '~/api/utils';
import { PlumbingProduct } from '~/core/models';
import { useAppSelector } from '~/redux/hooks';
import { selectSelectedColor } from '~/redux/slices/color';
import { selectZipcode } from '~/redux/slices/zipcode';

const emptyArray = [] satisfies PlumbingProduct[];

type UsePlumbingReturn = Omit<
  TypedUseQueryHookResult<
    PlumbingProduct[],
    CommonProductQueryParams,
    AxiosBaseQueryFunction
  >,
  'data' | 'isFetching' | 'isError'
> & {
  plumbingItems: PlumbingProduct[];
  isFetchingPlumbing: boolean;
  isErrorPlumbing: boolean;
};

export const usePlumbing = (): UsePlumbingReturn => {
  const zipCode = useAppSelector(selectZipcode);
  const selectedStore = useSelectedStore();
  const selectedColor = useAppSelector(selectSelectedColor);

  const shouldFetch = shouldFetchFn({
    args: [zipCode, selectedStore, selectedColor],
  });

  const params = {
    zipCode,
    storeId: selectedStore?.companyId,
    prodQteGrpID: selectedColor?.qteGrpID,
  };

  const {
    plumbingItems,
    isFetching: isFetchingPlumbing,
    isError: isErrorPlumbing,
    ...rest
  } = useFetchPlumbingQuery(shouldFetch ? { params } : skipToken, {
    selectFromResult: ({ data, ...rest }) => ({
      plumbingItems: data && data.length > 0 ? data : emptyArray,
      ...rest,
    }),
  });

  return {
    plumbingItems,
    isFetchingPlumbing,
    isErrorPlumbing,
    ...rest,
  };
};
